<template>
  <div>
    <EchoLastData
      :dataList="allPreviewlist"
      :model="renderData.model.topPreviewModel"
    />
    <Success>
      <div slot="content">
        <div class="tip">
          企业租赁主订单已经创建完成，您可选择继续为订单添加车辆
        </div>
        <div class="btn-box">
          <el-button @click="close">关闭</el-button>
          <el-button @click="goNewPage" type="primary">前往签约提车</el-button>
        </div>
      </div>
    </Success>
  </div>
</template>
<script>
import Success from '../../../components/Success.vue'
import EchoLastData from '../../../components/EchoLastData.vue'
import { allPreviewlist } from '../../config/echoLastData'

export default {
  components: {
    Success,
    EchoLastData,
  },
  props: {
    renderData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      allPreviewlist,
    }
  },
  methods: {
    close() {
      this.$refreshBack(false) // 关闭当前tab
      this.$router.push({
        path: '/car_to_lease/forRentSignContract',
        query: {
          activeName: 'primary',
        },
      })
    },
    goNewPage() {
      const { customerFormModel, customerTextModel, entRentOrderId } = this.renderData.model
      this.$refreshBack(false) // 关闭当前tab
      this.$router.push(
        {
          path: '/car_to_lease/forRentSignContract/enterSiginProcess',
          query: {
            // 客户名称
            customerId: customerFormModel.customerId || '',
            customerName: customerTextModel.customerName || '',
            entRentOrderId, // 主订单ID
          },
        },
      )
    },
  },
}
</script>
<style scoped lang='scss'>
.tip{
  font-weight: bold;
  margin: 30px 0;
}
.btn-box{
  padding-top: 30px;
}
</style>
